"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldsSchema = void 0;
const encharge_integration_schema_1 = require("encharge-integration-schema");
Object.defineProperty(exports, "FieldsSchema", { enumerable: true, get: function () { return encharge_integration_schema_1.FieldsSchema; } });
//# sourceMappingURL=fields_schema.js.map